﻿/* section-main-not-found */

class NotFoundSearch extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.typeInput = this.querySelector('[data-not-found-type-input]');
    this.categoryRoot = this.querySelector('[data-not-found-category-root]');
    this.categoryTrigger = this.querySelector('[data-not-found-category-trigger]');
    this.categoryDropdown = this.querySelector('[data-not-found-category-dropdown]');
    this.categoryLabel = this.querySelector('[data-not-found-category-label]');
    this.categoryValue = this.querySelector('[data-not-found-category-value]');
    this.categoryOptions = this.querySelectorAll('[data-not-found-category-option]');

    if (!this.form) {
      return;
    }

    this.defaultAction = this.form.getAttribute('action') || '/search';
    this.defaultCategoryLabel = this.categoryLabel?.textContent?.trim() || '';

    this.onSubmit = this.onSubmit.bind(this);
    this.onTriggerClick = this.onTriggerClick.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
    this.onOptionClick = this.onOptionClick.bind(this);

    this.form.addEventListener('submit', this.onSubmit);
    this.categoryTrigger?.addEventListener('click', this.onTriggerClick);

    this.categoryOptions.forEach((option) => {
      option.addEventListener('click', this.onOptionClick);
    });

    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onDocumentKeydown);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.onSubmit);
    this.categoryTrigger?.removeEventListener('click', this.onTriggerClick);
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onDocumentKeydown);
  }

  onTriggerClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const isOpen = this.categoryTrigger?.getAttribute('aria-expanded') === 'true';
    this.setDropdownOpen(!isOpen);
  }

  onOptionClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const option = event.currentTarget;
    const url = option.getAttribute('data-url') || '';
    const label = option.getAttribute('data-label') || this.defaultCategoryLabel;

    this.selectCategory(url, label);
    this.setDropdownOpen(false);
  }

  onDocumentClick(event) {
    if (!this.categoryRoot?.contains(event.target)) {
      this.setDropdownOpen(false);
    }
  }

  onDocumentKeydown(event) {
    if (event.key === 'Escape') {
      this.setDropdownOpen(false);
    }
  }

  onSubmit() {
    this.syncFormAction();
  }

  selectCategory(url, label) {
    if (this.categoryValue) {
      this.categoryValue.value = url;
    }

    if (this.categoryLabel) {
      this.categoryLabel.textContent = label;
    }

    this.categoryOptions.forEach((option) => {
      const optionUrl = option.getAttribute('data-url') || '';
      option.setAttribute('aria-selected', optionUrl === url ? 'true' : 'false');
    });

    this.syncFormAction();
  }

  setDropdownOpen(isOpen) {
    if (!this.categoryTrigger || !this.categoryDropdown) {
      return;
    }

    this.categoryTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    this.categoryDropdown.hidden = !isOpen;
  }

  syncFormAction() {
    const collectionUrl = this.categoryValue?.value;

    if (collectionUrl && collectionUrl.includes('/collections/')) {
      this.form.setAttribute('action', collectionUrl);
      this.typeInput?.remove();
      this.typeInput = null;
      return;
    }

    this.form.setAttribute('action', this.defaultAction);

    if (this.typeInput) {
      return;
    }

    const typeInput = document.createElement('input');
    typeInput.type = 'hidden';
    typeInput.name = 'type';
    typeInput.value = 'product';
    typeInput.setAttribute('data-not-found-type-input', '');
    this.form.prepend(typeInput);
    this.typeInput = typeInput;
  }
}

if (!window.customElements.get('not-found-search')) {
  window.customElements.define('not-found-search', NotFoundSearch);
}
